import type { ReactNode } from 'react';
import type { IconName } from '@shared/ui/icon/Icon';
import { Icon } from '@shared/ui/icon/Icon';

export interface EmptyStateProps {
  icon: IconName;
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * État vide professionnel et rassurant : icône, titre, description et action.
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2.5 rounded-lg border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
      <span className="flex size-10 items-center justify-center rounded-md bg-slate-100 text-slate-400">
        <Icon name={icon} size={20} />
      </span>
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      {description ? <p className="max-w-sm text-[13px] text-slate-500">{description}</p> : null}
      {action ? <div className="mt-1.5">{action}</div> : null}
    </div>
  );
}
